module.exports = __webpack_public_path__ + "static/media/boss-bar-yellow-01.55ed9f2f.png";